import { Outlet, useParams, useRouteError } from 'react-router';
import { useTranslation } from 'react-i18next';

import { ContentLayout, OrgLayout } from '@/components/layouts';
import { UserOnboardingCheck } from '@/features/users/components/user-onboarding-check';
import { OrgSelectCheck } from '@/features/orgs/components/org-select-check';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const { orgId } = useParams<{ orgId: string }>();
  const error = useRouteError();

  console.error(error);

  if (!orgId) {
    return <div>Organization ID is required</div>;
  }

  return (
    <OrgLayout orgId={orgId}>
      <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>
    </OrgLayout>
  );
};

const OrgRoot = () => {
  return (
    <UserOnboardingCheck>
      <OrgSelectCheck>
        <Outlet />
      </OrgSelectCheck>
    </UserOnboardingCheck>
  );
};

export default OrgRoot;
